import type { RefObject } from 'react'

import ChatContainer from '../containers/ChatContainer'
import type { AddBookingItems } from '../hooks/useAddedBookingItemIds'
import type { ComposerSubmitOptions } from '../hooks/useMessageContext'
import { useTripChatMobileAppShell } from './TripChatMobileAppShell'

interface Props {
  chatId: number | undefined
  isLoggedIn: boolean
  isDevMode: boolean
  isSpoofed: boolean
  hiddenFromCustomer: boolean
  spoofingAgentEmail?: string
  navigateToNewChatRoute: () => void
  addedBookingItemIds: ReadonlyArray<string>
  addBookingItems: AddBookingItems
  handleSubmit: (message: string, options?: ComposerSubmitOptions) => Promise<void>
  handleMultiChoiceSelectionChange: (selection: Array<string>) => void
  activeMultiChoiceSelection: Array<string>
  prefilledSelectionTags?: Array<string>
  mobileSelectionText: string | undefined
  offerContextTag: { label: string; offerId: string } | undefined
  handleRemoveTag: (tag: string) => void
  onRemovePrefilledSelectionTag?: () => void
  chatInputRef: RefObject<HTMLTextAreaElement | null>
}

function TripChatMobileChatView({
  chatId,
  isLoggedIn,
  isDevMode,
  isSpoofed,
  hiddenFromCustomer,
  spoofingAgentEmail,
  navigateToNewChatRoute,
  addedBookingItemIds,
  addBookingItems,
  handleSubmit,
  handleMultiChoiceSelectionChange,
  activeMultiChoiceSelection,
  prefilledSelectionTags,
  mobileSelectionText,
  offerContextTag,
  handleRemoveTag,
  onRemovePrefilledSelectionTag,
  chatInputRef,
}: Props) {
  const { activeTab } = useTripChatMobileAppShell()
  // The chat tab stays mounted while hidden. On List the floating composer
  // owns the Ask AI highlight, so the hidden chat input must not claim it as well.
  const deferAskAIHighlightToLocalComposer = activeTab === 'list'

  return (
    <ChatContainer
      chatId={chatId}
      isLoggedIn={isLoggedIn}
      isDevMode={isDevMode}
      isSpoofed={isSpoofed}
      hiddenFromCustomer={hiddenFromCustomer}
      spoofingAgentEmail={spoofingAgentEmail}
      navigateToNewChatRoute={navigateToNewChatRoute}
      handleSubmit={handleSubmit}
      handleMultiChoiceSelectionChange={handleMultiChoiceSelectionChange}
      activeMultiChoiceSelection={activeMultiChoiceSelection}
      prefilledSelectionTags={prefilledSelectionTags}
      mobileSelectionText={mobileSelectionText}
      offerContextTag={offerContextTag}
      handleRemoveTag={handleRemoveTag}
      onRemovePrefilledSelectionTag={onRemovePrefilledSelectionTag}
      addedBookingItemIds={addedBookingItemIds}
      addBookingItems={addBookingItems}
      chatInputRef={chatInputRef}
      autoFocusChatInput={false}
      deferAskAIHighlightToLocalComposer={deferAskAIHighlightToLocalComposer}
      isComposerVisible={activeTab === 'chat'}
      dismissKeyboardOnSubmit
      compactDisclaimer
      fitAvailableHeight
      showAddedItineraryItemLink
    />
  )
}

export default TripChatMobileChatView
